import { get } from 'lodash'
import T from 'prop-types'
import useSession from 'hooks/useSession'
import { getAge, getGender } from 'lib/birthNumber'

import getGenderText from '../../helpers/getGenderText'
import Step from '../../components/Step'
import YesOrNo from '../../components/YesOrNo'
import {
  handleClinicalInformationChange,
  buildClinicalQuestionsValidator,
} from './ClinicalInformation'

export const fertilePredicate = (values, user_id) => {
  const nationalId = values?.details?.on_behalf_of?.national_id || user_id
  const isFemale = getGender(nationalId) === 'FEMALE'
  const age = getAge(nationalId)

  return isFemale && age > 12 && age < 50
}

/**
 * List of clinical questions
 *
 * requiredValue is the value required to allow vaccination
 */
export const getOptions = (values = {}, user_id) => {
  if (!fertilePredicate(values, user_id)) {
    return []
  }

  return [
    {
      label: (
        <div>
          <p>
            {getGenderText('Ammer %s eller er %s', values)} <strong>gravid</strong>?
          </p>
        </div>
      ),
      name: 'IS_PREGNANT',
      description: (
        <div>
          <p>
            Ammende kvinner anbefales vaksinasjon. Det er ikke kjent risiko for overgang av
            koronavaksiner til morsmelk.
          </p>
          <p>
            Studier tyder på at koronavaksinasjon er trygt både for den gravide og fosteret, selv om
            erfaringen med vaksinering av gravide er begrenset. Vaksinering anbefales for alle
            gravide i 2. og 3. trimester.
          </p>
          <p>
            Risikofaktorer hos mor eller stor smitterisiko kan tilsi vaksinasjon i 1. trimester.
            Risikogruppene for alvorlig forløp av covid-19 hos gravide er de samme som for andre.
          </p>
        </div>
      ),
    },
  ]
}

export const validator = (values, user_id) =>
  buildClinicalQuestionsValidator(getOptions(values, user_id))

export default function WomanQuestions({ changeStep, values, onChange }) {
  const {
    session: { user_id },
  } = useSession()

  const handleChange = handleClinicalInformationChange(values, onChange)

  const disabled = !!validator(values, user_id).validate(values)?.error

  return (
    <Step title="Graviditet" onSubmit={changeStep} submitDisabled={disabled} submit="Gå videre">
      <YesOrNo
        values={get(values, 'vaccination.self_declaration', [])}
        onChange={handleChange}
        options={getOptions(values, user_id)}
      />
    </Step>
  )
}

WomanQuestions.propTypes = {
  changeStep: T.func.isRequired,
  values: T.object.isRequired,
  onChange: T.func.isRequired,
}
